export default "__VITE_ASSET__Cr6q9WKe__"